export const questionTypes = {
  Text: 'text',
  Rating: 'rating',
  Score: 'score', // Unclear what the difference of this has from Rating. - Tere, Sept 7, 2021
};
